export default [
  {
    path: '/vistoria/:vistoriaId/veiculo-ambiente',
    name: 'VistoriaVeiculo',
    component: () => import('./VeiculoAmbienteList'),
    meta: {
      routerGo: 'vistoria/:vistoriaId/veiculo-ambiente-new',
      routerEdit: '/ambiente-edit',
      domain: 'Vistoria',
      sidebar: false,
      icon: 'visibility',
      title: 'Ambientes',
    },
    children: [
      {
        path: '/ambiente/:id',
        name: 'ItensAmbienteVeiculo',
        component: () => import('./AmbienteForm/VeiculoAmbienteForm'),
        meta: {
          routerGo: '/ambiente/:id/itens-new',
          routerEdit: '/ambiente/:id/itens-edit',
          routerBack: '/ambiente',
          domain: 'ItensAmbienteVeiculo',
          sidebar: false,
          icon: 'keyboard_backspace',
          title: 'ItensAmbienteVeiculo',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/Veiculos/Vistoria/Ambiente/VeiculoAmbienteRouter.js